import { useEffect, useState } from "react"

// Measures an element's content height so collapse animations can target a
// real pixel value. Animating `height: "auto"` jumps in Safari.
// Callback-ref state, not a plain ref: sections mount as null while their
// query loads, so a mount-only effect would never see the element.
// Prefer border-box / scrollHeight over contentRect so padding we add as
// ring/shadow bleed is included and subpixel rounding does not clip.
export function useMeasuredHeight() {
	const [element, setElement] = useState<HTMLDivElement | null>(null)
	const [height, setHeight] = useState(0)
	useEffect(() => {
		if (!element) return
		const update = () => {
			setHeight(Math.ceil(element.scrollHeight))
		}
		update()
		const observer = new ResizeObserver(update)
		observer.observe(element)
		return () => observer.disconnect()
	}, [element])
	return [height, setElement] as const
}
